export const KEYS_LABEL: Record<string, string[]> = {
	Ejecutor: ['executor', 'executorTeam'],
	Supervisor: ['supervisor', 'supervisorTeam'],
	'Sustituto 1': ['substitute1', 'substitute1Team'],
	'Sustituto 2': ['substitute2', 'substitute2Team'],
};
